import { render, staticRenderFns } from "./ModalEditMotorista.vue?vue&type=template&id=5f886ae8"
import script from "./ModalEditMotorista.vue?vue&type=script&lang=ts"
export * from "./ModalEditMotorista.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports